import http from './api'

const route = 'app/comercial/cliente/'

export default {
  showClienteFaturados: (dataInicial, dataFinal, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor, classificacao, linhaProducao, cidades, clientes) => {
    return http.post(route + 'showClienteFaturados', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhaProducao: linhaProducao,
      cidades: cidades,
      clientes: clientes,
    })
  },

  showClienteLocalizacao: (dataInicial, dataFinal, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor, classificacao, linhaProducao, cidades, clientes) => {
    return http.post(route + 'showClienteLocalizacao', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhaProducao: linhaProducao,
      cidades: cidades,
      clientes: clientes,
    })
  },

  showDetalheClienteFaturados: (dataInicial, dataFinal, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, segmento, receita, categoria, promotor, clientes) => {
    return http.post(route + 'showDetalheClienteFaturados', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      segmento: segmento,
      receita: receita,
      categoria: categoria,
      promotor: promotor,
      clientes: clientes,
    })
  },

  showDetalheTotalCliente: (dataInicial, dataFinal, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor, clientes) => {
    return http.post(route + 'showDetalheTotalCliente', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      segmento: segmento,
      receita: receita,
      categoria: categoria,
      promotor: promotor,
      clientes: clientes,
    })
  },

  showLocalizacaoClientes: (dataInicial, dataFinal, select, tokenContrato, areaSelect, redeSelect, supervisorSelect) => {
    return http.post(route + 'showLocalizacaoClientes', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
    })
  },

  showClienteNovos: (dataInicial, dataFinal, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor, classificacao, linhaProducao, cidades, clientes) => {
    return http.post(route + 'showClienteNovos', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhaProducao: linhaProducao,
      cidades: cidades,
      clientes: clientes,
    })
  },

  showNovosClienteFaturados: (dataInicial, dataFinal, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor, clientes) => {
    return http.post(route + 'showNovosClienteFaturados', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      clientes: clientes,
    })
  },

  showComparativoCliente: (dataInicial, dataFinal, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor, classificacao, linhaProducao, cidades, clientes) => {
    return http.post(route + 'showComparativoCliente', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhaProducao: linhaProducao,
      cidades: cidades,
      clientes: clientes,
    })
  },

  showDistribuicaoClienteAnual: (dataInicial, dataFinal, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor, classificacao, linhaProducao, cidades, clientes) => {
    return http.post(route + 'showDistribuicaoClienteAnual', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhaProducao: linhaProducao,
      cidades: cidades,
      clientes: clientes,
    })
  },

  showClienteSemFaturamento: (dataInicial, dataFinal, select, tokenContrato, vendedores, areaSelect, redeSelect, supervisorSelect, receita, segmento) => {
    return http.post(route + 'showClienteSemFaturamento', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      tokenContrato: tokenContrato,
      vendedores: vendedores,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
    })
  },

  showClienteSemFaturamentoRede: (dataInicial, dataFinal, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor, classificacao, linhaProducao, cidades, clientes) => {
    return http.post(route + 'showClienteSemFaturamentoRede', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhaProducao: linhaProducao,
      cidades: cidades,
      clientes: clientes,
    })
  },

  showMelhoresCliente: (dataInicial, dataFinal, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor, classificacao, linhaProducao, cidades, clientes) => {
    return http.post(route + 'showMelhoresCliente', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhaProducao: linhaProducao,
      cidades: cidades,
      clientes: clientes,
    })
  },

  showSegmentacaoCliente: (dataInicial, dataFinal, select, tokenContrato, vendedores, areaSelect, redeSelect, supervisorSelect, receita, segmento) => {
    return http.post(route + 'showSegmentacaoCliente', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      tokenContrato: tokenContrato,
      vendedores: vendedores,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
    })
  },

  showSegmentacaoRedeCliente: (dataInicial, dataFinal, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor, classificacao, linhaProducao, cidades, clientes) => {
    return http.post(route + 'showSegmentacaoRedeCliente', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhaProducao: linhaProducao,
      cidades: cidades,
      clientes: clientes,
    })
  },

  showClientesDevolucao: (dataInicial, dataFinal, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor, classificacao, linhaProducao, cidades, clientes) => {
    return http.post(route + 'showClientesDevolucao', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhaProducao: linhaProducao,
      cidades: cidades,
      clientes: clientes,
    })
  },

  showDetalheDevolucao: (dataInicial, dataFinal, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, idCliente, categoria, promotor, classificacao, linhaProducao, cidades) => {
    return http.post(route + 'showDetalheDevolucao', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      idCliente: idCliente,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhaProducao: linhaProducao,
      cidades: cidades,
    })
  },

  showClientesDevolucaoImpropria: (dataInicial, dataFinal, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor, classificacao, linhaProducao, cidades) => {
    return http.post(route + 'showClientesDevolucaoImpropria', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhaProducao: linhaProducao,
      cidades: cidades,
    })
  },

  showPerformanceTicketMedioCliente: (dataInicial, dataFinal, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor, classificacao, linhaProducao, cidades, clientes) => {
    return http.post(route + 'showPerformanceTicketMedioCliente', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhaProducao: linhaProducao,
      cidades: cidades,
      clientes: clientes,
    })
  },

  showClienteMaioresCrescimento: (dataInicial, dataFinal, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor, classificacao, linhaProducao, cidades, clientes) => {
    return http.post(route + 'showClienteMaioresCrescimento', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhaProducao: linhaProducao,
      cidades: cidades,
      clientes: clientes,
    })
  },

  showClientePioresCrescimento: (dataInicial, dataFinal, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor, classificacao, linhaProducao, cidades, clientes) => {
    return http.post(route + 'showClientePioresCrescimento', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhaProducao: linhaProducao,
      cidades: cidades,
      clientes: clientes,
    })
  },

  showDetalheMelhoresClienteFaturados: (dataInicial, dataFinal, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor, classificacao, clientes) => {
    return http.post(route + 'showDetalheMelhoresClienteFaturados', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      clientes: clientes,
    })
  },

  showClienteCampeoes: (dataInicial, dataFinal, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showClienteCampeoes', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showClienteLeais: (dataInicial, dataFinal, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showClienteLeais', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showClienteHibernando: (dataInicial, dataFinal, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showClienteHibernando', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showNovosCliente: (dataInicial, dataFinal, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, promotor) => {
    return http.post(route + 'showNovosCliente', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      promotor: promotor,
    })
  },

  showClientePreocupantes: (dataInicial, dataFinal, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showClientePreocupantes', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showClientesPromissoresEPotencias: (dataInicial, dataFinal, select, tokenContrato, vendedorSelect, areaSelect, redeSelect, supervisorSelect) => {
    return http.post(route + 'showClientesPromissoresEPotencias', {
      dataInicio: dataInicial,
      dataFim: dataFinal,
      select: select,
      tokenContrato: tokenContrato,
      vendedor: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
    })
  },

  showLocalizacaoClientesRFC: (dadosCampeoes, dadosPromissores, dadosPotencias, dadosLeais, dadosHibernando, dadosRisco, dadosNovos, dadosPreocupantes, dadosNaoPerder, tokenContrato, dataInicial, dataFinal, vendedorSelect, areaSelect, redeSelect, supervisorSelect, receita, segmento, select, categoria, promotor) => {
    return http.post(route + 'showLocalizacaoClientesRFC', {
      dadosCampeoes: dadosCampeoes,
      dadosPromissores: dadosPromissores,
      dadosPotenciais: dadosPotencias,
      dadosLeais: dadosLeais,
      dadosHibernando: dadosHibernando,
      dadosRisco: dadosRisco,
      dadosNovos: dadosNovos,
      dadosPreocupantes: dadosPreocupantes,
      dadosNaoPerder: dadosNaoPerder,
      tokenContrato: tokenContrato,
      dataInicio: dataInicial,
      dataFim: dataFinal,
      vendedores: vendedorSelect,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      select: select,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showDadosCliente: (tokenContrato) => {
    return http.post(route + 'showDadosCliente', {
      tokenContrato: tokenContrato,
    })
  },

  showClienteFaturamento: (primeiroDia, ultimoDia, select, selectCliente, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showClienteFaturamento', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      selectCliente: selectCliente,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showDadosComparativoFaturamentoClientes: (primeiroDia, ultimoDia, select, selectCliente, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showDadosComparativoFaturamentoClientes', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      selectCliente: selectCliente,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showQuantidadeClientes: (primeiroDia, ultimoDia, select, selectCliente, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showQuantidadeClientes', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      selectCliente: selectCliente,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showTicketMedioClientes: (primeiroDia, ultimoDia, select, selectCliente, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showTicketMedioClientes', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      selectCliente: selectCliente,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showClientesEvolucaoSemestral: (primeiroDia, ultimoDia, select, selectCliente, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showClientesEvolucaoSemestral', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      selectCliente: selectCliente,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showClientesMixComercializado: (primeiroDia, ultimoDia, select, selectCliente, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showClientesMixComercializado', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      selectCliente: selectCliente,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showClientesPerfilMixComprado: (primeiroDia, ultimoDia, select, selectCliente, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showClientesPerfilMixComprado', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      selectCliente: selectCliente,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showExtratoClientesDevolucao: (primeiroDia, ultimoDia, select, selectCliente, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento) => {
    return http.post(route + 'showExtratoClientesDevolucao', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      selectCliente: selectCliente,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
    })
  },

  showExtratoClientesDevolucaoImpropria: (primeiroDia, ultimoDia, select, selectCliente, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showExtratoClientesDevolucaoImpropria', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      selectCliente: selectCliente,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showClientesProdutoVenderEFocar: (primeiroDia, ultimoDia, select, selectCliente, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showClientesProdutoVenderEFocar', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      selectCliente: selectCliente,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showClientesProdutoVenderEFocarClassificacao: (primeiroDia, ultimoDia, select, selectCliente, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showClientesProdutoVenderEFocarClassificacao', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      selectCliente: selectCliente,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showDadosABCClientes: (primeiroDia, ultimoDia, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showDadosABCClientes', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showClientesMatrizRiscoRFV: (primeiroDia, ultimoDia, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showClientesMatrizRiscoRFV', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showDelhamentoClientesSemFaturamento: (primeiroDia, ultimoDia, select, vendedorSelect, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor, classificacao, clientes) => {
    return http.post(route + 'showDelhamentoClientesSemFaturamento', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      vendedores: vendedorSelect,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      clientes: clientes,
    })
  },

  showDetalheClientesDevolucaoImpropria: (primeiroDia, ultimoDia, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor) => {
    return http.post(route + 'showDetalheClientesDevolucaoImpropria', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showDetalhePerformanceTicketMedioCliente: (primeiroDia, ultimoDia, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor, clientes) => {
    return http.post(route + 'showDetalhePerformanceTicketMedioCliente', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      clientes: clientes,
    })
  },

  showDetalheClienteMaioresCrescimento: (primeiroDia, ultimoDia, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor, clientes) => {
    return http.post(route + 'showDetalheClienteMaioresCrescimento', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      clientes: clientes,
    })
  },

  showDetalheClientePioresCrescimento: (primeiroDia, ultimoDia, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento, categoria, promotor, clientes) => {
    return http.post(route + 'showDetalheClientePioresCrescimento', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      clientes: clientes,
    })
  },

  showExtratoSomenteClienteMixComercializado: (primeiroDia, ultimoDia, clientes, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita) => {
    return http.post(route + 'showExtratoSomenteClienteMixComercializado', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      clientes: clientes,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
    })
  },

  showExtratoSomenteClienteProdutosVender: (primeiroDia, ultimoDia, clientes, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receita, segmento) => {
    return http.post(route + 'showExtratoSomenteClienteProdutosVender', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      clientes: clientes,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receita,
      segmento: segmento,
    })
  },

  showDetalheClienteSemFaturados: (primeiroDia, ultimoDia, select, vendedores, tokenContrato, areaSelect, redeSelect, supervisorSelect, receitaSelect, categoria, promotor, clientes) => {
    return http.post(route + 'showDetalheClienteSemFaturados', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      vendedores: vendedores,
      tokenContrato: tokenContrato,
      area: areaSelect,
      rede: redeSelect,
      supervisor: supervisorSelect,
      receita: receitaSelect,
      categoria: categoria,
      promotor: promotor,
      clientes: clientes,
    })
  },

  showFatPrincipaisClientes: (primeiroDia, ultimoDia, select, supervisor, area, rede, vendedor, receita, tokencontrato, segmento, categoria, promotor, classificacao, linhaProducao, cidades, clientes) => {
    return http.post(route + 'showFatPrincipaisClientes', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      vendedores: vendedor,
      supervisor: supervisor,
      area: area,
      rede: rede,
      receita: receita,
      tokenContrato: tokencontrato,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      linhaProducao: linhaProducao,
      cidades: cidades,
      clientes: clientes,
    })
  },

  showBaseAtendimentoCliente: (primeiroDia, ultimoDia, select, supervisor, area, rede, vendedor, receita, tokencontrato, segmento, categoria, promotor, classificacao, cidade, linhaProducao) => {
    return http.post(route + 'showBaseAtendimentoCliente', {
      dataInicio: primeiroDia,
      dataFim: ultimoDia,
      select: select,
      vendedores: vendedor,
      supervisor: supervisor,
      area: area,
      rede: rede,
      receita: receita,
      tokenContrato: tokencontrato,
      segmento: segmento,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      cidade: cidade,
      linhaProducao: linhaProducao,
    })
  },
}
